import ReceiptTax from 'components/receipt/commons/CountingBox/ReceiptTax'
import Subtotal from 'components/receipt/commons/CountingBox/Subtotal'
import Gratuity from 'components/receipt/commons/CountingBox/Gratuity'
import styles from './RefundCountingBox.css'

class RefundCountingBox extends React.Component {
  render () {
    let {paymentDetail, paymentRefund} = this.props
    // noinspection JSUnresolvedVariable
    return (paymentRefund.is_refund_breakdown && <div className={styles['refund-counting-box']}>
      <Subtotal subtotal={this.calculateSubTotal(paymentRefund)} />
      {paymentDetail.enable_gratuity && <Gratuity gratuities={paymentRefund.payment_gratuities}
        includeGratuityTax={paymentDetail.include_gratuity_tax} />}

      {paymentDetail.enable_tax && <ReceiptTax taxes={paymentRefund.payment_taxes}
        includeGratuityTax={paymentDetail.include_gratuity_tax} />}
    </div>)
  }

  calculateSubTotal = (paymentDetail) => {
    let subtotal = 0
    let checkouts = paymentDetail.checkouts

    for (let x = 0; x < checkouts.length; x++) {
      let checkoutDiscounts = checkouts[x].discounts
      let totalDiscounts = 0

      for (let y = 0; y < checkoutDiscounts.length; y++) {
        totalDiscounts += parseFloat(checkoutDiscounts[y].discount_amount)
      }

      subtotal += checkouts[x].price - totalDiscounts
    }

    let paymentDiscounts = paymentDetail.payment_discounts

    for (let x = 0; x < paymentDiscounts.length; x++) {
      subtotal -= paymentDiscounts[x].discount_amount
    }

    subtotal -= paymentDetail.total_redeem_amount
    return subtotal
  }
}

RefundCountingBox.propTypes = {
  paymentDetail: React.PropTypes.object,
  paymentRefund: React.PropTypes.object
}

export default RefundCountingBox



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/CountingBox/RefundCountingBox.js